/**
 * Formats category names for display
 * @param category - The category string to format
 * @returns Formatted category name
 */
export function formatCategory(category: string): string {
  if (!category) return 'Uncategorized';
  
  // Handle special cases
  const specialCases: Record<string, string> = {
    'apps': 'Apps',
    'mobile app': 'Mobile App',
    'saas': 'SaaS Product',
    'ai ml': 'AI/ML Project',
    'ecommerce': 'E-commerce',
    'content': 'Content Platform',
    'social': 'Social Platform'
  };
  
  // Return special case if exists
  if (specialCases[category.toLowerCase()]) {
    return specialCases[category.toLowerCase()];
  }
  
  // Default: capitalize first letter of each word
  return category
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
